import { render, staticRenderFns } from "./InterpretationRevalidationHistoryTable.vue?vue&type=template&id=1e909323&"
import script from "./InterpretationRevalidationHistoryTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationRevalidationHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports